export default "__VITE_ASSET__COKBoNfE__"